import React from "react";
import classNames from "classnames";

export const Feature = ({ icon, title, description, appearance }) => {
  return (
    <div
      className={classNames("feature", {
        [`feature--${appearance}`]: appearance,
      })}
    >
      <div className="feature__icon">{icon}</div>
      <div className="feature__content">
        <div className="feature__title">{title}</div>
        <div className="feature__description">{description}</div>
      </div>
    </div>
  );
};

const FeatureList = ({ appearance, children }) => {
  children = Array.isArray(children) ? children : [children];
  return (
    <ul
      className={classNames("feature-list", {
        [`feature-list--${appearance}`]: appearance,
      })}
    >
      {children.map((child, index) => (
        <li
          key={child.key ?? `empty-${index}`}
          className="feature-list__element"
        >
          {child}
        </li>
      ))}
    </ul>
  );
};

export default FeatureList;
